const API_INTEGRATION_TYPES = {
  SYNDIGO: 'SYNDIGO',
  SYNDIGO_MARKET_PLACE: 'SYNDIGO_MARKET_PLACE',
  GS1: 'GS1',
};

const API_INTEGRATION_OPTIONS = [
  { label: 'SYNDIGO', value: API_INTEGRATION_TYPES.SYNDIGO },
  { label: 'SYNDIGO Market Place', value: API_INTEGRATION_TYPES.SYNDIGO_MARKET_PLACE },
  { label: 'GS1', value: API_INTEGRATION_TYPES.GS1 },
];

export { API_INTEGRATION_TYPES, API_INTEGRATION_OPTIONS };
